import {AccentService, HtmlUtils} from "inet-core";

export class MessageContact {
  private static _accent = new AccentService();
  fullname: string = '';
  usercode: string = '';
  lastmsg: number = 0;
  message: string = '';
  online: boolean = false;
  unread: number = 0;
  type?: string; // COMPANY | FRIEND
  _indexSearch: string = '';

  constructor(options: any) {
    Object.assign(this, options);
    // this.message = HtmlUtils.formatHtmlDisplay(this.message);

    this._indexSearch = MessageContact._accent.viToEn(this.fullname.toLowerCase()) + ' ';
    // Remove suffix email "@inetcloud.vn"
    this._indexSearch += MessageContact._accent.viToEn(this.usercode.slice(0, this.usercode.indexOf('@')));
  }

  isMatch(keyword: string = '') {
    return this._indexSearch.indexOf(MessageContact._accent.viToEn(keyword)) > -1;
  }
}
